import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import moment from 'moment';
import { getDatepickerLocale } from '@/helpers/LocaleHelper';
import { NotificationField } from '@/modules/Notifications/interfaces/Notification';
import CustomNavLink from '@/modules/Notifications/components/CustomNavLink.vue';

interface Props {
    notificationData: NotificationField;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalNotification',
  props: {
    notificationData: null
  },
  setup(__props: any) {

const props = __props as {
    notificationData: NotificationField;
};



const locale = computed(() => getDatepickerLocale());

const routingData = computed(() => props.notificationData.navigation);

const notificationDate = computed(() =>
    moment(new Date(props.notificationData.createdAt)).format(locale.value.lang.dateTimeFormat),
);

return { __sfc: true,props, locale, routingData, notificationDate, CustomNavLink }
}

})